export default "__VITE_ASSET__45fb4629__"